<template>
  <v-container>
    <v-layout wrap class="mt-4">
      <v-flex xs12 class="text-right">
        <v-btn
          color="primary"
          class="content"
          v-if="bool_grant"
          @click="dialog = !dialog"
          >Cargar documentos</v-btn
        >
      </v-flex>
      <div
        class="font-italic"
        style="font-size: 15px"
        v-if="!documentsList.length"
      >
        No hay documentos para mostrar.
      </div>
      <v-flex xs12>
        <div v-for="doc in documentsList" :key="doc.link" class="pt-3">
          <v-layout wrap>
            <v-flex xs6
              ><p class="text body-1 pl-2">{{ doc.name }}</p></v-flex
            >
            <v-flex xs5
              ><a class="text body-1">{{ doc.link.slice(0, 30) }}...</a></v-flex
            >
            <v-icon color="black" @click="deleteFiles(doc)">mdi-close </v-icon>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>

    <!-- Dialog for add documents -->
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="grey lighten-2" primary-title
          >Subir documentos
        </v-card-title>
        <v-card-text>
          Usted puede elegir un máximo de
          {{
            10 - this.documentsList.length >= 0
              ? 10 - this.documentsList.length
              : 0
          }}
          documentos.
          <label class="btn btn-primary">
            <i class="fa fa-folder-open-o" aria-hidden="true"></i>&nbsp;
            <input
              type="file"
              accept=".docx, .pdf"
              id="files"
              ref="files"
              multiple
              v-on:change="onFileSelected"
            />
          </label>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="saveFile">Guardar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--SnackBar for errors-->
    <v-snackbar v-model="snackbar" :right="true" :timeout="3000" :top="true">
      {{ messageSnack }}
      <v-btn color="pink" text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { storage, firestore, auth } from "firebase";

export default {
  data() {
    return {
      projectId: undefined,
      userId: undefined,
      bool_grant: false,
      dialog: false,
      messageSnack: "",
      snackbar: false,
      files: [],
      documentsList: []
    };
  },
  computed: {
    ...mapGetters("projects", ["getProject"])
  },
  mounted() {
    this.projectId = this.$route.params.project_id;
    this.userId = auth().currentUser.uid;
    // eslint-disable-next-line no-console
    console.log(this.userId);

    const storageRef = storage().ref("/" + this.projectId);
    storageRef
      .listAll()
      .then(res => {
        res.items.forEach(itemRef => {
          itemRef.getDownloadURL().then(url =>
            this.documentsList.push({
              name: itemRef.fullPath.split("/")[1],
              link: url
            })
          );
        });
      })
      // eslint-disable-next-line no-console
      .catch(err => console.error(err));

    // get full_name of user
    firestore()
      .collection("User")
      .doc(this.userId)
      .onSnapshot(result => {
        const data = result.data();
        let first_name = data.first_name ? data.first_name : "";
        let last_name = data.last_name ? data.last_name : "";
        let full_name_user = first_name + " " + last_name;
        if (full_name_user.trim() == this.getProject.owner.full_name) this.bool_grant = true;
      });
  },

  methods: {
    onFileSelected() {
      this.files = this.$refs.files.files;
    },

    saveFile() {
      if (this.files.length + this.documentsList.length > 10) {
        this.messageSnack = "Error: Maximo de archivos permitidos es 10.";
        this.snackbar = true;

        return;
      }

      for (let i = 0; i < this.files.length; i++) {
        const file = this.files[i];
        const name = file.name;

        storage()
          .ref()
          .child("/" + this.projectId + "/" + name)
          .put(file)
          .then(snapshot => {
            // eslint-disable-next-line no-console
            console.log("Upload Success: ", snapshot);
            storage()
              .ref("/" + this.projectId + "/" + name)
              .getDownloadURL()
              .then(url => {
                this.documentsList.push({
                  name: name,
                  link: url
                });
              });
          });
      }
      this.dialog = false;
    },

    deleteFiles(doc) {
      var r = confirm("¿Estás seguro que quieres eliminar el documento?");
      if (r == true) {
        storage()
          .ref()
          .child("/" + this.projectId + "/" + doc.name)
          .delete()
          .then( () => {
            this.message_delete = "Su documento se ha eliminado correctamente";
            this.snackbarDelete = true;
            this.documentsList.splice(this.documentsList.indexOf(doc), 1);
            this.documentsList;
            // eslint-disable-next-line no-console
            console.log("Los documentos fueron actualizados");
          })
          .catch(() => {
            // eslint-disable-next-line no-console
            console.log("No se pudo eliminar el archivo ", doc.name);
          });
      } else {
        // eslint-disable-next-line no-console
        console.log("No se eliminó el documento");
      }
    }
  }
};
</script>

<style>
.cursor {
  cursor: pointer;
}

.content {
  margin-right: 3px;
}
</style>
